import { useEffect, useRef } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../../config/firebase";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useInactivityLogout = (timeout = 10 * 60 * 1000) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      signOut(auth)
        .then(() => {
          toast.info("You've been logged out due to inactivity.");
          navigate("/admin-login");
        })
        .catch((err) => {
          console.error("Auto logout failed:", err);
          toast.error("Failed to auto-logout");
        });
    }, timeout);
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // Start timer on mount

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timerRef.current);
    };
  }, []);
};

export default useInactivityLogout;
